import { apiSlice } from "../../../features/api/apiSlice";

export type Permission = {
  id: number;
  name: string;
  guard_name: string;
  created_at?: string;
  updated_at?: string;
};

export type Role = {
  id: number;
  name: string;
  guard_name: string;
  permissions?: Permission[];
};

export type Designation = {
  id: number;
  name: string;
  role_id: number | null;
  role?: Role | null;
  created_at?: string;
  updated_at?: string;
};

function pickData(res: any) {
  return res?.data?.data ?? res?.data ?? res;
}

export const designationsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // LIST
    getDesignations: builder.query<Designation[], void>({
      query: () => "/designations",
      transformResponse: (res: any) => pickData(res) || [],
      providesTags: (result) =>
        result
          ? [
              ...result.map((d) => ({
                type: "Designations" as const,
                id: d.id,
              })),
              { type: "Designations" as const, id: "LIST" },
            ]
          : [{ type: "Designations" as const, id: "LIST" }],
    }),

    // CREATE
    createDesignation: builder.mutation<Designation, { name: string }>({
      query: (body) => ({
        url: "/designations",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Designations" as const, id: "LIST" }],
    }),

    // DETAILS
    getDesignation: builder.query<Designation, number>({
      query: (id) => `/designations/${id}`,
      transformResponse: (res: any) => pickData(res),
      providesTags: (_res, _err, id) => [{ type: "Designations" as const, id }],
    }),

    // UPDATE
    updateDesignation: builder.mutation<
      Designation,
      { id: number; name: string }
    >({
      query: ({ id, ...body }) => ({
        url: `/designations/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_res, _err, { id }) => [
        { type: "Designations" as const, id },
        { type: "Designations" as const, id: "LIST" },
      ],
    }),

    // DELETE
    deleteDesignation: builder.mutation<
      { status?: string; message?: string },
      number
    >({
      query: (id) => ({
        url: `/designations/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Designations" as const, id: "LIST" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetDesignationsQuery,
  useCreateDesignationMutation,
  useGetDesignationQuery,
  useUpdateDesignationMutation,
  useDeleteDesignationMutation,
} = designationsApi;
